var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 92,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-3.2%",
    y: "-3.8%",
    width: "106.4%",
    height: "110.8%",
    filterUnits: "objectBoundingBox",
    id: "icon-search-home_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0",
    "in": "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-search-home_svg__a)",
    transform: "translate(-175 -65)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#C3F1E3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M236.715 119.088l6.328 6.388-6.113 6.172-6.333-6.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.316 137.813c2.245 2.268 2.245 5.952 0 8.225a5.733 5.733 0 01-8.153 0l-12.226-12.34a1.458 1.458 0 010-2.056l6.11-6.17a1.438 1.438 0 012.042 0l12.227 12.34zM212.48 70.26c16.714 0 30.262 13.673 30.262 30.536 0 16.866-13.548 30.535-30.262 30.535-16.706 0-30.255-13.669-30.255-30.535 0-16.863 13.549-30.537 30.255-30.537z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.48 76.804c13.133 0 23.778 10.74 23.778 23.992 0 13.25-10.645 23.994-23.778 23.994-13.126 0-23.771-10.743-23.771-23.994s10.645-23.992 23.771-23.992z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#C3F1E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M201 84h21v41h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.238 88.437h10.082M200.238 92.798H206M200.238 121.334c3.58 2.177 7.762 3.456 12.242 3.456 3.329 0 6.495-.696 9.37-1.94M221.85 85.397c0-.73-.587-1.324-1.31-1.324h-18.992c-.724 0-1.31.594-1.31 1.324",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.513 106.658l-8.086-4.445a2.599 2.599 0 00-2.51 0l-11.975 6.58v1.454h21.393a24.022 24.022 0 001.178-3.589zM210.327 114.663V99.94a1.32 1.32 0 00-1.312-1.324h-14.671c-.723 0-1.308.594-1.308 1.324v14.63c.355.508.715-.385 1.11.094h16.18z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.612 117.519h-2.878a1.45 1.45 0 00-1.445 1.454v3.175a23.837 23.837 0 005.521-3.94c-.255-.407-.686-.69-1.198-.69z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.289 118.973a1.45 1.45 0 011.444-1.454h2.879c.512 0 .943.282 1.198.688a24.067 24.067 0 005.525-7.96h-19.69v14.432a23.38 23.38 0 008.644-2.53v-3.176z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.032 103.978h17.288M193.032 109.34h17.288M193.032 114.703h17.288M206 123.336v.546M197.542 119.427c3.71 3.047 8.532 4.866 12.785 5.252v-5.252h-12.785z",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.742 119.427h12.585v-4.764h-17.182c1.361 1.662 2.845 3.522 4.597 4.764z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.85 103.899V85.397M200.238 85.397v13.218",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
export default SvgIconSearchHome;